import React, { useState, useRef, useEffect } from "react";
import cn from "classnames";
import Select from "components/ui/Select";
import "styles/components/gatwick-express-input.scss";
import useLayout from "hooks/useLayout";
import useModal from "hooks/useModal";
import { find } from "lodash";
import GatwickModal from "./others/GatwickModal";
import ErrorMessage from "./ui/ErrorMessage";

const options = [
  {
    value: "choose",
    label: "Choose a journey...",
    disabled: true,
  },
  {
    value: "gatolo",
    label: "Gatwick Airport to London Victoria",
    stationTo: {
      address:
        "London Victoria station\nVictoria Street\nLondon\nGreater London\nSW1V 1JU",
      nlc: "5426",
      name: "London Victoria",
    },
    stationFrom: {
      address:
        "Gatwick Airport station\nSouth Terminal\nGatwick Airport\nWest Sussex\nRH6 0RD",
      nlc: "5416",
      name: "Gatwick Airport",
    },
  },
  {
    value: "lotoga",
    label: "London Victoria to Gatwick Airport",
    stationTo: {
      address:
        "Gatwick Airport station\nSouth Terminal\nGatwick Airport\nWest Sussex\nRH6 0RD",
      nlc: "5416",
      name: "Gatwick Airport",
    },
    stationFrom: {
      address:
        "London Victoria station\nVictoria Street\nLondon\nGreater London\nSW1V 1JU",
      nlc: "5426",
      name: "London Victoria",
    },
  },
  {
    value: "britoga",
    label: "Brighton to Gatwick Airport",
    stationTo: {
      address:
        "Gatwick Airport station\nSouth Terminal\nGatwick Airport\nWest Sussex\nRH6 0RD",
      nlc: "5416",
      name: "Gatwick Airport",
    },
    stationFrom: {
      address: "Brighton station\nQueens Road\nBrighton\nEast Sussex\nBN1 3XP",
      name: "Brighton",
      nlc: "5268",
    },
  },
  {
    value: "gatobri",
    label: "Gatwick Airport to Brighton",
    stationTo: {
      address: "Brighton station\nQueens Road\nBrighton\nEast Sussex\nBN1 3XP",
      name: "Brighton",
      nlc: "5268",
    },
    stationFrom: {
      address:
        "Gatwick Airport station\nSouth Terminal\nGatwick Airport\nWest Sussex\nRH6 0RD",
      nlc: "5416",
      name: "Gatwick Airport",
    },
  },
  {
    value: "lotobri",
    label: "London Victoria to Brighton",
    stationTo: {
      address: "Brighton station\nQueens Road\nBrighton\nEast Sussex\nBN1 3XP",
      name: "Brighton",
      nlc: "5268",
    },
    stationFrom: {
      address:
        "London Victoria station\nVictoria Street\nLondon\nGreater London\nSW1V 1JU",
      nlc: "5426",
      name: "London Victoria",
    },
  },
  {
    value: "britolo",
    label: "Brighton to London Victoria",
    stationTo: {
      address:
        "London Victoria station\nVictoria Street\nLondon\nGreater London\nSW1V 1JU",
      nlc: "5426",
      name: "London Victoria",
    },
    stationFrom: {
      address: "Brighton station\nQueens Road\nBrighton\nEast Sussex\nBN1 3XP",
      name: "Brighton",
      nlc: "5268",
    },
  },
];

const GatwickExpressInput = ({
  className,
  clearErrors,
  errors,
  modalClassName,
  location = true,
  placeholder,
  setValue,
  ...props
}) => {
  const [type, setType] = useState(options[0]);
  const { isMobile, isDesktopDevice } = useLayout();
  const { closeModal, showModal } = useModal();

  const skipFocus = useRef(false);

  // When the modal closes, it will automatically focus the input.
  const onModalClose = () => {
    skipFocus.current = true;
  };

  const onInputFocus = () => {
    if (skipFocus.current) {
      // Skip opening the modal the first time we focus after the modal closed
      // (to avoid be trapped in the modal forever)
      skipFocus.current = false;
    } else {
      // Otherwise we're going to open it
      handleModalTrigger();
    }
  };

  const handleChange = (item) => {
    const selected = find(options, ["value", item]);
    setValue("stationFrom", selected.stationFrom);
    setValue("stationTo", selected.stationTo);
    setType(selected);
    clearErrors("stationFrom");
    closeModal();
  };

  const handleModalTrigger = (event) => {
    showModal(
      <GatwickModal
        options={options}
        type={type}
        handleChange={handleChange}
        closeModal={closeModal}
      />,
      { autoFocus: false, onClose: onModalClose }
    );
  };

  const hasErrors = Object.keys(errors).some((errorType) =>
    ["stationFrom"].includes(errorType)
  );

  return isMobile && !isDesktopDevice ? (
    <>
      <input
        className={cn("otrl-jp__gatwick-express__type", {
          "otrl-jp__gatwick-express__type--error": hasErrors,
        })}
        autocomplete="off"
        data-lpignore="true"
        onClick={handleModalTrigger}
        onKeyUp={handleModalTrigger}
        onChange={handleModalTrigger}
        onFocus={onInputFocus}
        name={"gatwick_input"}
        value={type?.label || ""}
        {...props}
      />
      <ErrorMessage errors={errors} name={"stationFrom"} />
    </>
  ) : (
    <div className="otrl-jp__gatwick-express">
      <Select
        className={cn("otrl-jp__gatwick-express__type", {
          "otrl-jp__gatwick-express__type--error": hasErrors,
        })}
        onChange={handleChange}
        value={type?.value}
        options={options}
      />
      <ErrorMessage errors={errors} name={"stationFrom"} />
    </div>
  );
};

export default GatwickExpressInput;
